import { ToastContainer } from "material-react-toastify";
import { useEffect, useState } from "react";
import SuspenseScreen from "./router/suspense-screen";
import Router from "./router";
import useInfo from "./utils/context/info-context";
import useAuth from "./utils/context/auth-context";
import useCart from "./utils/context/cart-context";
import SignInReminderPopup from "./components/signin-reminder";
import { useLocation } from "react-router-dom";

function App() {
  const { init } = useInfo();
  const [authInit, setAuthInit] = useState<boolean>(false);
  const { me , auth, reminder , init: _auth_init  } = useAuth();
  const { getCart } = useCart();
  const location = useLocation();

  useEffect(() => {
    i();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const i = async () => {
    await me();
    await getCart();
    setAuthInit(true);
  };

  const isAuthPages =
  (location.pathname as string) === "/auth/register" ||
  (location.pathname as string) === "/auth/login" ||
  (location.pathname as string) === "/auth/forget-password" ||
  (location.pathname as string) === "/sso/login";

  return (
    <div className="w-full overflow-x-hidden">
      {init && authInit ? <Router /> : <SuspenseScreen />}
      {!auth && init && _auth_init && reminder && !isAuthPages ? (
        <SignInReminderPopup />
      ) : null}
      <ToastContainer position="top-right" className="mt-32  md:mt-16" />
    </div>
  );
}

export default App;
